import { MONTH_NAMES_PT } from '../lib/utils';

export const MonthHeader = ({ month }) => {
  return (
    <div 
      className="month-header border-slate-200 dark:border-slate-800"
      data-testid={`month-header-${month}`}
    >
      <h2 
        className="text-4xl md:text-5xl font-black uppercase tracking-tight text-slate-200 dark:text-slate-800 select-none"
        style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
      >
        {MONTH_NAMES_PT[month - 1]}
      </h2>
    </div>
  );
};

export default MonthHeader;
